<div class="col-12  white-background common-border-radius accordian">
  <p-fieldset [toggleable]="true" icon="fa fa-filter" [title]="'label_filters'| translate"
    (onAfterToggle)="onAfterToggle($event)" [collapsed]="collapsed">
    <div class="col-12 p-0 grid">
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>lbl_dispatch_zones</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="serviceCitiesOptions"
            [(ngModel)]="selectedDispatchAddress"
            (onChange)="changeFilter('selectedDispatchAddress',selectedDispatchAddress)"
            [filter]="true"
            maxSelectedLabels="0"
            [selectedItemsLabel]="selectedDispatchAddress.length === 1 ? '{0} item' : '{0} items'"
            [placeholder]="'label_all' | translate">
          </p-multiSelect>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>lbl_pickup_location</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="pickupLocationsOptions"
            [(ngModel)]="selectedPickupLocation"
            (onChange)="changeFilter('selectedPickupLocation',selectedPickupLocation)"
            [placeholder]="pickupDropPlaceHolder"
            [filter]="true"
            maxSelectedLabels="0"
            [selectedItemsLabel]="selectedPickupLocation.length === 1 ? '{0} item' : '{0} items'">
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>lbl_drop_location</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="pickupLocationsOptions"
            [(ngModel)]="selectedDropLocation"
            (onChange)="changeFilter('selectedDropLocation',selectedDropLocation)"
            [placeholder]="pickupDropPlaceHolder"
            [filter]="true"
            maxSelectedLabels="0"
            [selectedItemsLabel]="selectedDropLocation.length === 1 ? '{0} item' : '{0} items'">
          </p-multiSelect>
        </div>
      </div>

      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_from_date_filter</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-calendar #rangePicker [(ngModel)]="fromDate" [dateFormat]="dateFormat" [showIcon]="true" readonlyInput="true"
            (onSelect)="onSelectDates($event,'fromDate')">
          </p-calendar>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_to_date_filter</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-calendar #rangePicker [(ngModel)]="toDate" [dateFormat]="dateFormat" [showIcon]="true" [minDate]="minDate"
            readonlyInput="true" (onSelect)="onSelectDates($event,'toDate')"></p-calendar>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-2">
        <div class="form-label">
          <label for="serviceType" translate>label_vehicle_type</label>
        </div>
        <div class="form-control">
          <p-multiSelect [style]="{'width': '100%'}" [options]="vehicleTypeOptions" [(ngModel)]="selectedVehicleTypeId"
            (onChange)="changeFilter('selectedVehicleTypeId',selectedVehicleTypeId)"
            maxSelectedLabels="0" [selectedItemsLabel]="selectedVehicleTypeId.length === 1 ? '{0} item' : '{0} items'"
            [placeholder]="'label_all' | translate">
            </p-multiSelect>
        </div>
      </div>
    </div>


    <div class="col-12 p-0 grid">
      <!-- <div class="col-12 md:col-4 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>lbl_passenger_Type</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="passengerTypeOptions" [(ngModel)]="selectedPassengerType"
        (onChange)="changeFilter('selectedPassengerType',selectedPassengerType)">
        </p-dropdown>
      </div>
    </div> -->

      <div class="col-12 md:col-2 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_status</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-multiSelect
            [options]="statusListFilterOptions"
            [(ngModel)]="selectedBookingStatus"
            maxSelectedLabels="0"
            (onChange)="changeFilter('selectedBookingStatus',selectedBookingStatus)"
            [selectedItemsLabel]="selectedBookingStatus.length === 1 ? '{0} item' : '{0} items'"
            [placeholder]="'label_all' | translate">
          </p-multiSelect>
        </div>
      </div>

      <!-- <div class="col-12 md:col-2 lg:col-2">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_journey_type</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="journeyTypeOptions" [(ngModel)]="selectedJourneyType"
        (onChange)="changeFilter('selectedJourneyType',selectedJourneyType)">
        </p-dropdown>
      </div>
    </div> -->

      <div class="col-12 md:col-2 lg:col-2">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_sort_by_list</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-dropdown [options]="sortTypeOptions" [(ngModel)]="selectedSortType"
            (onChange)="changeFilter('selectedSortType',selectedSortType)">
          </p-dropdown>
        </div>
      </div>

      <div class="col-12 md:col-2 lg:col-2" *ngIf="showETAFilter">
        <div class="form-label">
          <label for="companyId" class="list-filter-lbl" translate>label_drop_off_in</label>
        </div>
        <div class="form-control filter-drop-down">
          <p-dropdown [options]="etaTimeOptions" [(ngModel)]="nextAvailableTime"
            (onChange)="changeFilter('nextAvailableTime',nextAvailableTime)">
          </p-dropdown>
        </div>
      </div>

      <div [ngClass]="showETAFilter ? 'col-12 md:col-6 lg:col-6' : 'col-12 md:col-8 lg:col-8'">
        <div class="form-label">
          <label for="endtDate">&nbsp;</label>
        </div>
        <button [ngClass]="filterApplied? 'filter-btn-apply filter-applied' : 'filter-btn-apply'" pButton appRipple
          (click)="onclickFilterApply()" type="button" icon="fa fa-check" [label]="'label_apply' | translate"></button>
        <button pButton appRipple class="reset-btn" (click)="resetFilter()" type="button" icon="fa fa-undo"
          [label]="'label_reset' | translate"></button>
      </div>

    </div>
  </p-fieldset>

  <div class="col-12 p-0 pt-2" *ngIf="loadGrid()">
    <app-mi-grid-v2 [url]="url" [columnDefs]="columns" [paginationPageSize]="paginationCount" [overflowShow]="true"
      [uniqId]="uniqId" [searchPlaceHolder]="searchPlaceHolder" [urlMethod]="urlMethod"
      [bodyMapping]="bodyMapping" appLogicalAccessProvider accessCode="VIEW_OUTBOUND_BOOKINGS" [exportUrl]="exportUrl"
      accessGroupCode="CURRENT_BOOKINGS" (rowClickedEvent)="onRowClicked($event)" (totalCount)="totalCount($event)"
      rowSelection="multiple" (dropDownEvent)="changeBookingStatus($event)" (clickEtaEmmiter)="getLatestEta($event)"
      (editClickEvent)="changeDispatchLocation($event)" divClass="mi-grid"
      [gridScrollHeight]="gridScrollHeight" [showActionLegend]="true"></app-mi-grid-v2>
  </div>
</div>

<!-- Old assign driver p-sidebar flow kept for reference.
<p-sidebar class="assign-driver-with-booking" *ngIf="hasShowDriverSideBar" [(visible)]="hasShowDriverSideBar"
  position="right" [showCloseIcon]="false" [style]="{width:'100%'}">
  <ng-template pTemplate="header">
    <div class="header inner-header assignDriverHeader col-12 py-2 pr-4 mb-2 pb-0 pl-5">
      <div class="grid col-12 flex align-items-center pb-0">
        <div (click)="backNavigate()" class="back-navigation-icon col-1" title="Back"></div>
        <div class="col-5 py-0">
          <div class="bookingTime mb-2">{{bookingInfo?.tourBookingInfo?.pickupDateTimeStr}}</div>
          <div class="tourBookingId">Booking ID {{bookingInfo?.tourBookingInfo?.tripId}}</div>
        </div>
        <div class="col-6 flex justify-content-end flex-auto pr-5">
          <span>
            <span class="subHeading" translate>label_status</span>&nbsp;
            <span class="bookingStatus">{{bookingInfo?.tourBookingInfo?.tourStatusString}}</span>
          </span>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="grid">
    <div class="sidebarBookingDetails col-3 lg:col-3 md:col-3 p-3">
      <app-sidebar-booking-details [bookingDetail]="bookingDetails" [bookingInfo]="bookingInfo"></app-sidebar-booking-details>
    </div>
    <div class="assign-content col-9 lg:col-9 md:col-9">
      <app-sidebar-assign-driver [bookingDetail]="bookingDetails" (sideBarHide)="sideBarHideFromShaired()"
        (showThirdPartyPopUp)="showThirdPartyPopUp()" [fromComponent]="subBookingType"></app-sidebar-assign-driver>
    </div>
  </div>
</p-sidebar>
-->
@if(hasShowDriverSideBar){
  <app-assign-driver-v2 [(visible)]="hasShowDriverSideBar" [bookingId]="bookingDetails?.id"
  (sideBarHide)="sideBarHideFromShaired()"></app-assign-driver-v2>
}

<p-dialog modal="true" position="center" autoResize="false" styleClass="assign-search dispatch-location-dialog-div"
  [(visible)]="bookingCancelsPopup" [contentStyle]="{'overflow':'auto','width':'700px','padding-top': '0px'}">
  <p-header class="key-text1">
    {{selectParkingLocationHeader}}
  </p-header>
  <div class="form-container scroll-bar-css scroll-dialog-div">
    <form class="col-12">
      <div class="form-field">
        <div class="form-control">
          <div class="col-12">
            <div class="col-12 md:col-12 lg:col-12 grid">
              <div class="col-3 md:col-3 lg:col-3 key-text" translate>label_parking_locations</div>
              <div class="col-3 md:col-4 lg:col-4 key-text" translate>ETA(Estimated Time Of Arrival)</div>
              <div class="col-3 md:col-2 lg:col-2 key-text" translate>label_distance</div>
              <div class="col-3 md:col-2 lg:col-2 key-text marg-l-8px" translate>grid_actions</div>
            </div>
            <div class="col-12 md:col-12 lg:col-12 ss1 grid" [ngClass]="selectedClass(eachLocation)"
              *ngFor="let eachLocation of dispatchLocations">
              <div class="col-3 md:col-3 lg:col-3" translate>{{eachLocation.displayAddress}}</div>
              <div class="col-4 md:col-4 lg:col-4" translate>{{eachLocation.etaString?eachLocation.etaString:'--'}}
              </div>
              <div class="col-2 md:col-2 lg:col-2" translate>
                {{eachLocation.distanceString?eachLocation.distanceString:'--'}}</div>
              <div class="col-1 md:col-1 lg:col-1 col-offset-1">
                <button appAccessProvider pButton appRipple type="button" label="Select"
                  [disabled]="selectedClass(eachLocation)" (click)="onSelectDispatchLocation(eachLocation)"></button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-12  form-buttons">
      </div>
    </form>
  </div>
</p-dialog>

<p-dialog [header]="'label_cancel_booking' | translate" [(visible)]="showCustomDialog" [modal]="true"
  styleClass="cancel_luggage_popup" position="center center" responsive="true"
  [contentStyle]="{'overflow':'auto', 'border-radius': 0, 'max-height': '60vh'}" class="cancel-booking-popup">
  <div class="col-12 cancel-booking">
    <p-table class="table-cancel-booking" [value]="bookingToCancel" [(selection)]="selectedBookingToCancel"
      dataKey="tripId">
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-tableHeaderCheckbox [disabled]="showHideSelectAll"></p-tableHeaderCheckbox>
          </th>
          <th translate>label_BookingId</th>
          <th translate>label_booking_status</th>
          <th translate>label_driver_info</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-associateBooking>
        <tr>
          <td>
            <p-tableCheckbox [value]="associateBooking"
              [disabled]="isBookingDisabled(associateBooking.tourStatus)"></p-tableCheckbox>
          </td>
          <td>{{ associateBooking.tripId }}</td>
          <td>{{ associateBooking.tourStatusStr }}</td>
          <td>
            <ng-container
              *ngIf="associateBooking.driverName || associateBooking.vehicleCode || associateBooking.vehicleRegistration || associateBooking.vehicleMakeModel || associateBooking.vehicleModelName; else noData">
              <div class="driver-name" *ngIf="associateBooking.driverName">
                {{ associateBooking.driverName }}
              </div>
              <div class="vehicle-code" *ngIf="associateBooking.vehicleCode">
                {{ associateBooking.vehicleCode }} - {{ associateBooking.vehicleRegistration }}
              </div>
              <div class="vehicle-make" *ngIf="associateBooking.vehicleMakeModel">
                {{ associateBooking.vehicleMakeModel }} | {{ associateBooking.vehicleModelName }}
              </div>
            </ng-container>
            <ng-template #noData> NA </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="col-12 grid align-items-center">
    <div class="col-1 pl-3">
      <img src="/assets/images/temp/canel-booking-warning-icon.svg" alt="img">
    </div>
    <div class="col-11 cancel-info">
      You cannot cancel the booking whose status is <span style=" font-weight: 900;">On Trip / Completed.</span>
      Do you wish to proceed?
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div>
      <button class="negative-button" pButton appRipple type="button" [label]="'label_cancel' | translate"
        (click)="closeCancellation()"></button>
      <button class="confirmBtn" pButton appRipple type="button" [label]="'label_submit' | translate"
        [disabled]="selectedBookingToCancel.length === 0" (click)="confirmCustomCancellation()"></button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="fa fa-question-circle"></p-confirmDialog>

<app-merge-booking-popup 
  (onMergeComplete)="onMergeComplete($event)"
  (onClose)="onMergePopupClose()">
</app-merge-booking-popup>

<app-cancellation-reason-popup
  [(visible)]="showCancellationReasonPopup"
  [selectedBookingForCancellation]="selectedBookingForCancellation"
  [eventId]="eventIdParam"
  (onConfirm)="onCancellationConfirm($event)"
  (onCancel)="closeCancellationReasonPopup()">
</app-cancellation-reason-popup>